import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { AuthorizationsPage } from '@apps/web/components/authorizations/authorizations_page';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import { canUseAuthorizations } from '@apps/web/lib/authorizations';
import { useOrganizationDataSourceAccounts } from '@apps/web/swr_data_fetching/data_fetching_hooks';
import { useOrganization } from '@apps/web/swr_data_fetching/organization_queries';

export const Route = createFileRoute('/_app/(main)/authorizations')({
    component: AuthorizationsRoute,
    head: () => ({
        meta: [
            {
                title: 'Authorizations | Phoebe',
            },
        ],
    }),
});

function AuthorizationsRoute() {
    const organizationId = useOrganizationId();
    const { data: organization } = useOrganization(organizationId, {
        reason: 'authorizations-route-guard',
    });
    const { data: dataSourceAccounts } = useOrganizationDataSourceAccounts(
        organizationId,
        { reason: 'authorizations-route-guard' },
    );
    const navigate = useNavigate();
    const isLoaded = Boolean(organization && dataSourceAccounts);
    const canUseAuth = canUseAuthorizations(
        organization?.features,
        dataSourceAccounts,
    );

    useEffect(() => {
        if (isLoaded && !canUseAuth) {
            navigate({ to: '/', replace: true });
        }
    }, [canUseAuth, isLoaded, navigate]);

    if (!isLoaded || !canUseAuth) {
        return null;
    }

    return <AuthorizationsPage />;
}
